/**
 * Route gate for the two-way SMS pages: renders children only when the server probe
 * sms_conversations_available() answers true. Loading shows a spinner; false or error redirects,
 * so a bare URL never shows the surface to someone the server would refuse.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useSmsConversationsAvailable } from "../../hooks/useSmsConversationsAvailable";

const SmsConversationsGate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { available, loading } = useSmsConversationsAvailable();
  if (loading) {
    return (
      <div className="flex items-center justify-center p-12">
        <div
          className="h-8 w-8 animate-spin rounded-full border-b-2 border-primary-600"
          aria-hidden="true"
        />
      </div>
    );
  }
  if (!available) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
};

export default SmsConversationsGate;
